export const GET_VERIFICATIONS_REQUESTS_LIST_REQUEST =
  "GET_VERIFICATIONS_REQUESTS_LIST_REQUEST";
export const GET_VERIFICATIONS_REQUESTS_LIST_RESPONSE =
  "GET_VERIFICATIONS_REQUESTS_LIST_RESPONSE";

export const GET_VERIFICATION_REQUEST_MAIN_INFO =
  "GET_VERIFICATION_REQUEST_MAIN_INFO";

export const GET_OFFPLATFORM_VERIFICATION_REQUEST_DETAILS_REQUEST =
  "GET_OFFPLATFORM_VERIFICATION_REQUEST_DETAILS_REQUEST";
export const GET_OFFPLATFORM_VERIFICATION_REQUEST_DETAILS_RESPONSE =
  "GET_OFFPLATFORM_VERIFICATION_REQUEST_DETAILS_RESPONSE";

export const GET_ONLINE_PAYMENT_VERIFICATION_REQUEST_DETAILS_REQUEST =
  "GET_ONLINE_PAYMENT_VERIFICATION_REQUEST_DETAILS_REQUEST";
export const GET_ONLINE_PAYMENT_VERIFICATION_REQUEST_DETAILS_RESPONSE =
  "GET_ONLINE_PAYMENT_VERIFICATION_REQUEST_DETAILS_RESPONSE";

export const GET_BANK_TRANSFER_VERIFICATION_REQUEST_DETAILS_REQUEST =
  "GET_BANK_TRANSFER_VERIFICATION_REQUEST_DETAILS_REQUEST";
export const GET_BANK_TRANSFER_VERIFICATION_REQUEST_DETAILS_RESPONSE =
  "GET_BANK_TRANSFER_VERIFICATION_REQUEST_DETAILS_RESPONSE";

export const SEND_REQUIRED_VERIFICATION_DOCUMENTS_REQUEST =
  "SEND_REQUIRED_VERIFICATION_DOCUMENTS_REQUEST";

export const APPROVE_OFF_PLATFORM_DOCS = "APPROVE_OFF_PLATFORM_DOCS";
export const REQUEST_EDIT_OFF_PLATFORM_DOCS =
  "REQUEST_EDIT_OFF_PLATFORM_DOCS";

export const APPROVE_VERIFICATION_REQUEST =
  "APPROVE_VERIFICATION_REQUEST";
export const REJECT_VERIFICATION_REQUEST =
  "REJECT_VERIFICATION_REQUEST";
